import { FolderKanban, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function ProjectsPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Projects</h1>
          <p className="text-sm text-foreground-muted">Manage projects consisting of multiple print jobs</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          New Project
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<FolderKanban className="h-10 w-10" />}
          title="No projects yet"
          description="Create projects to organize multiple print jobs. Add models to your queue and track progress across complex builds."
          actionLabel="New Project"
          onAction={() => {
            // TODO: Open new project modal
          }}
        />
      </div>
    </div>
  );
}
